module.exports = __webpack_public_path__ + "static/media/iQuoto-Global-Logo-Blue.4a791d68.svg";